module.exports = __webpack_public_path__ + "weixin/img/slider2.6567a423.png";